import {
  ASSET_TYPE_ALERT,
  ASSET_TYPE_LIST_DATA,
  ASSET_CLASS_TYPE_LIST_DATA,
  ASSET_TYPE_SINGLE_DATA,
} from '../actions/types';

const initialState = {
  data: {},
  isAlert: false,
  alertType: null,
  alertMessage: null,
  typeData: [],
  classData: [],
};

function assetjsonReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ASSET_CLASS_TYPE_LIST_DATA:
      return {
        ...state,
        classData: payload,
      };
    case ASSET_TYPE_SINGLE_DATA:
      return {
        ...state,
        data: payload,
      };
    case ASSET_TYPE_LIST_DATA:
      return {
        ...state,
        typeData: payload,
      };
    case ASSET_TYPE_ALERT:
      return {
        ...state,
        isAlert: payload.isAlert,
        alertType: payload.alertType,
        alertMessage: payload.alertMessage,
      };
    default:
      return state;
  }
}

export default assetjsonReducer;
